///// <reference path="../../reference.ts" />
import {utils} from '../../utils'
import ItemLayout from '../item/itemLayout.js'
import GroupLayout from '../group/groupLayout.js'

class Strip {

  constructor(lastIdx) {
    this.ratio = 0;
    this.groups = [];
    this.height = 0;
    this.idx = (lastIdx || 0) + 1;
  }
}

class GalleryLayout {

  constructor(layoutParams) {

    this.ready = false;
    this.pointer = 0;
    this.layoutItems = [];

    this.findNeighborItem = this.findNeighborItem.bind(this);

    this.updateParams(layoutParams);
    this.prepareGallery();
  }

  updateParams(layoutParams) {

    this.items = layoutParams.items;
    this.styleParams = layoutParams.styleParams;
    this.container = layoutParams.container;
    this.gotScrollEvent = layoutParams.gotScrollEvent;
    this.watermark = layoutParams.watermark;
    this.showAllItems = layoutParams.showAllItems;
  }

  verifyGalleryState() {
    if (!this.container.galleryWidth) {
      this.ready = false;
      this.reason = 'galleryWidth is undefined or 0';
      return false;
    }

    if (!this.styleParams.gallerySize) {
      this.ready = false;
      this.reason = 'gallerySize is undefined or 0';
      return false;
    }

    return true;
  }

  prepareGallery() {

    var gallerySize = Math.floor(this.styleParams.gallerySize);
    var galleryWidth = Math.floor(this.container.galleryWidth);
    var maxGroupSize = this.maxGroupSize;

    if (!this.verifyGalleryState()) {
      return false;
    }

    this.srcImages = this.items;

    this.pointer = 0;
    this.firstGroup = false;
    this.layoutItems = [];

    var groupIdx = 1;
    var inStripIdx = 1;
    var item = {};

    var groupItems = [];
    var group;
    var bounds = this.container.bounds;

    var strip = new Strip();

    var numOfCols = 1;
    var columns = [];
    var columnsH = [];

    var galleryHeight = 0;

    var safetyCounter = 1000000;

    if (this.styleParams.isVertical) {
      if (this.styleParams.fixedColumns > 0) {
        numOfCols = utils.isMobile() ? 1 : this.styleParams.fixedColumns;
      } else {
        numOfCols = Math.ceil(galleryWidth / gallerySize) || 1;
      }
      gallerySize = Math.floor(galleryWidth / numOfCols);
    } else {
      numOfCols = 1;
      gallerySize = Math.min(this.styleParams.gallerySize, galleryWidth);
    }

    while (this.srcImages[this.pointer]) {

      if (_.isArray(this.srcImages[this.pointer])) {
        console.error({msg: 'no dto', pointer: this.pointer, allItems: this.srcImages});
      }

      //console.log('Creating item #' + this.pointer + ' / ' + this.srcImages.length, this.srcImages[this.pointer]);
      item = new ItemLayout({
        idx: this.pointer,
        scrollTop: galleryHeight,
        dto: this.srcImages[this.pointer],
        watermark: this.watermark,
        cubeImages: this.styleParams.cubeImages,
        cubeType: this.styleParams.cubeType,
        cubeRatio: this.styleParams.cubeRatio,
        smartCrop: this.styleParams.smartCrop,
        cropOnlyFill: this.styleParams.cropOnlyFill,
        sharpParams: this.styleParams.sharpParams,
        createdBy: 'galleryLayout'
      });

      this.layoutItems[this.pointer] = item;

      //push the image to a group - until its full
      groupItems.push(item);
      if ( //conditions to wait for the next item
      !this.isLastImages //last images in gallery - do not group
      &&
      (groupItems.length < maxGroupSize) //if the group is too small
      ) {
        //wait for more images
        this.pointer++;
        continue;
      }

      group = new GroupLayout({
        idx: groupIdx,
        stripIdx: strip.idx,
        inStripIdx: inStripIdx,
        top: galleryHeight,
        items: groupItems,
        chooseBestGroup: this.styleParams.chooseBestGroup,
        groupTypes: this.styleParams.groupTypes,
        cubeImages: this.styleParams.cubeImages,
        cubeType: this.styleParams.cubeType,
        isVertical: this.styleParams.isVertical,
        minItemSize: this.styleParams.minItemSize,
        gallerySize: gallerySize,
        collageAmount: this.styleParams.collageAmount,
        collageDensity: this.styleParams.collageDensity,
        layoutsVersion: this.styleParams.layoutsVersion,
        titlePlacement: this.styleParams.titlePlacement,
        galleryLayout: this.styleParams.galleryLayout,
        allowTitle: this.styleParams.allowTitle,
        itemFont: this.styleParams.itemFont,
        itemFontSlideshow: this.styleParams.itemFontSlideshow,
      });

      groupIdx++;
      inStripIdx++;

      //prepare the images in the group
      //group = this.wrapGroup(groupImages);
      if (group.items.length < maxGroupSize) {
        //console.warn(group.items.length, '<' ,maxGroupSize, 'waiting for more');
        //move the cursor back if the resulted group is smaller than 3
        if (safetyCounter > 0) {
          safetyCounter--;
          this.pointer += (group.items.length - groupItems.length);
        } else {
          console.error('safetyCounter Reached!', this);
        }
      }

      groupItems = [];

      //resize and fit the group in the strip / column
      if (!this.styleParams.isVertical) {

        //STRIPS

        //open a new strip if needed
        var isStripSmallEnough;

        if (this.styleParams.oneRow) {
          isStripSmallEnough = false; //onerow layout is one long strip

        } else {
          var withNewGroup = ((galleryWidth / (strip.ratio + group.ratio)) - gallerySize); //start a new strip BEFORE adding the current group
          var withoutNewGroup = ((galleryWidth / (strip.ratio)) - gallerySize); //start a new strip AFTER adding the current group

          if (isNaN(withNewGroup) || isNaN(withoutNewGroup)) {
            isStripSmallEnough = false;
          } else if (withoutNewGroup < 0) {
            //the strip is already too small
            isStripSmallEnough = true;
          } else if (withNewGroup < 0) {
            //adding the new group makes is small enough
            // check if adding the new group makes the strip TOO small
            //so - without the new group, the strip is larger than the required size - but adding the new group might make it too small
            isStripSmallEnough = (Math.abs(withoutNewGroup) < Math.abs(withNewGroup));

          } else {
            isStripSmallEnough = false;
          }

/*
          if (isStripSmallEnough && this.isLastImage) {
            //if it is the last image - prefer adding it to the last strip rather putting it on a new strip
            isStripSmallEnough = ((Math.abs(withoutNewGroup) * 1) < Math.abs(withNewGroup));
          }
*/
        }

        var shouldStartNewStrip = false;
        shouldStartNewStrip = (
          (!strip.groups) //first image - restart a new strip
          ||
          (
            (strip.groups.length > 0) //strip must have at least one group
            &&
            isStripSmallEnough
          )
        );

        if (shouldStartNewStrip) {
          //close the current strip
          if (strip.groups) {
            strip.groups[strip.groups.length - 1].isLastGroup = true;
            strip.groups[strip.groups.length - 1].stripWidth = galleryWidth;
            this.resizeGroups(strip.groups, (galleryWidth / strip.ratio));
            galleryHeight += (galleryWidth / strip.ratio);
            columns[0] = (columns[0] || []).concat(strip.groups);
          }

          //open a new strip
          strip = new Strip(strip.idx);

          //reset the group (this group will be rebuilt)
          inStripIdx = 1;
          this.pointer -= (group.items.length - 1);
          groupIdx--;
          continue;
        }

        //add the group to the (current/new) strip
        group.setTop(galleryHeight);
        group.stripIdx = strip.idx;
        strip.ratio += group.ratio;
        strip.height = Math.min(gallerySize, (galleryWidth / strip.ratio));
        strip.groups.push(group);

        if (this.isLastImage && strip.groups) {
          if (this.styleParams.oneRow) {
            strip.height = this.container.galleryHeight;
          } else {
            if (gallerySize * 2 < (galleryWidth / strip.ratio)) {
              //stretching the strip to the full width will make it too high - so make it as high as the gallerySize and not stretch
              strip.height = gallerySize;
            } else {
              strip.height = (galleryWidth / strip.ratio);
            }
          }

          strip.groups[strip.groups.length - 1].isLastGroup = true;
          strip.groups[strip.groups.length - 1].stripWidth = strip.height * strip.ratio;

          this.resizeGroups(strip.groups, strip.height);
          galleryHeight += (strip.height);
          columns[0] = (columns[0] || []).concat(strip.groups);
        }

      } else {

        //find the shortest column
        var minCol = 0;
        var minColH = -1;
        for (var i = 0; i < numOfCols; i++) {
          var colH = columnsH[i];
          if (typeof(colH) == 'undefined') {
            colH = 0;
          }
          if (colH < minColH || minColH < 0) {
            minColH = colH;
            minCol = i;
          }
          if (galleryHeight < colH) {
            galleryHeight = colH;
          }
        }

        columns[minCol] = columns[minCol] || [];
        columnsH[minCol] = columnsH[minCol] || 0;

        //resize the gourp and images
        this.resizeGroups([group], (gallerySize / group.ratio));

        //update the group's position
        group.setTop(columnsH[minCol]);
        group.setLeft(minCol * gallerySize);

        //add the image to the column
        columns[minCol].push(group);

        //add the image height to the column
        columnsH[minCol] += group.totalHeight;

        if (galleryHeight < columnsH[minCol]) {
          galleryHeight = columnsH[minCol];
        }

      }

      //set the group visibility
      //until the first scroll event, make sure the first 10 groups are displayed

      if (!this.gotScrollEvent && this.pointer < 10) {
        group.visible = group.rendered = group.required = true;
      } else {
        group = this.calcVisibilitiesForGroup(group, bounds);
      }

      if (!this.firstGroup) {
        this.firstGroup = group;
      }

      //advance the this.pointer
      this.pointer++;
    }

    //results
    this.lastGroup = group;
    this.strips = strip.idx || 0;
    this.columns = columns;
    this.colWidth = Math.floor(galleryWidth / numOfCols);
    this.height = galleryHeight;

    this.calcVisibilities(bounds);

    this.ready = true;
  }

  lastVisibleItemIdx() {
    for (let item, i = this.layoutItems.length - 1; item = this.layoutItems[i]; i--) {
      const isVisible = item.offset.top < (this.container.galleryHeight - 100); //the item must be visible and about the show more button
      if (isVisible) {
        return i;
      }
    }
    return this.layoutItems.length - 1;
  }

  findNeighborItem(itemIdx, dir) {

    const currentItem = this.layoutItems[itemIdx];

    let neighborItem;

    const findClosestItem = (currentItemX, currentItemY, condition) => {

      let minDistance = null;
      let minDistanceItem = {};

      let itemY;
      let itemX;
      let distance;

      // _.each(_.slice(this.layoutItems, itemIdx - 50, itemIdx + 50), (item) => {
      _.each(this.layoutItems, (item) => {
        itemY = item.offset.top + (item.height / 2);
        itemX = item.offset.left + (item.width / 2);
        distance = Math.sqrt(Math.pow(itemY - currentItemY, 2) + Math.pow(itemX - currentItemX, 2));
        if ((minDistance == null || (distance > 0 && distance < minDistance)) && condition(currentItemX, currentItemY, itemX, itemY)) {
          minDistance = distance;
          minDistanceItem = item;
        }
      });
      return minDistanceItem;
    };

    switch (dir) {
      case 'up':
        neighborItem = findClosestItem(
          (currentItem.offset.left + (currentItem.width / 2)),
          (currentItem.offset.top),
          (curX, curY, itmX, itmY) => itmY < curY
        );
        break;

      case 'left':
        neighborItem = findClosestItem(
          (currentItem.offset.left),
          (currentItem.offset.top + (currentItem.height / 2)),
          (curX, curY, itmX, itmY) => itmX < curX
        );
        break;

      case 'down':
        neighborItem = findClosestItem(
          (currentItem.offset.left + (currentItem.width / 2)),
          (currentItem.offset.bottom),
          (curX, curY, itmX, itmY) => itmY > curY
        );
        break;

      case 'right':
        neighborItem = findClosestItem(
          (currentItem.offset.right),
          (currentItem.offset.top + (currentItem.height / 2)),
          (curX, curY, itmX, itmY) => itmX > curX
        );
        break;

    }

    if (neighborItem.idx >= 0) {
      if (utils.isDev()) {
        console.log('found neighborItem #' + neighborItem.idx, neighborItem);
      }
      return neighborItem.idx;
    } else {
      console.warn('Could not find offset for itemIdx', itemIdx, dir);
      return itemIdx; //stay on the same item
    }

  }

  calcVisibilities(bounds) {
    if (utils.shouldDebug('ph_log_visibilities')) {
      console.log('Calculating Visibilities for groups', bounds, this.columns);
    }
    for (var column, c = 0; column = this.columns[c]; c++) {
      for (var group, g = 0; group = column[g]; g++) {
        column[g] = this.calcVisibilitiesForGroup(group, bounds);
        if (utils.shouldDebug('ph_log_visibilities')) {
          console.log('Calculating Visibilities - group #' + column[g].idx + ' is ' + (column[g].visible ? 'VISIBLE' : (column[g].rendered ? 'RENDERED' : 'HIDDEN')), column[g], bounds);
        }
      }
    }
  }

  calcVisibilitiesForGroup(group, bounds) {
    if (this.showAllItems === true) {
      group.visible = group.rendered = group.required = true;
    } else if (this.styleParams.oneRow) {
      group.visible = group.right >= bounds.visibleTop && group.left <= bounds.visibleBottom;
      group.rendered = group.right >= bounds.renderedTop && group.left <= bounds.renderedBottom;
      group.required = group.right >= bounds.requiredTop && group.left <= bounds.requiredBottom;
    } else {
      group.visible = group.bottom >= bounds.visibleTop && group.top <= bounds.visibleBottom;
      group.rendered = group.bottom >= bounds.renderedTop && group.top <= bounds.renderedBottom;
      group.required = group.bottom >= bounds.requiredTop && group.top <= bounds.requiredBottom;
    }
    return group;
  }

  resizeGroups(groups, height) {
    var left = 0;
    var remainder = 0;
    for (var group, g = 0; group = groups[g]; g++) {
      group.setLeft(left);
      // group.left = (left);
      group.width += remainder; //add the remainder from the last group round
      group.resizeByHeight(height);
      remainder = group.width;
      group.round();
      remainder -= group.width;
      left += group.width;
    }
  }

  get isLastImage() {
    return !this.srcImages[this.pointer + 1];
  }

  get isLastImages() {
    if (this.styleParams.layoutsVersion > 1) {
      //layouts version 2+
      return !this.srcImages[this.pointer + 1];
    } else {
      //Backwards compatibility
      return !this.srcImages[this.pointer + 3]
    }
  }

  get imagesLeft() {
    return this.srcImages.length - this.pointer - 1;
  }

  get maxGroupSize() {
    var _maxGroupSize = 1;
    try {
      var groupTypes = _.isString(this.styleParams.groupTypes) ? this.styleParams.groupTypes.split(',') : this.styleParams.groupTypes;
      _maxGroupSize = groupTypes.reduce((curSize, groupType) => {
        return Math.max(curSize, parseInt(groupType))
      }, 1);
      _maxGroupSize = Math.min(_maxGroupSize, this.styleParams.groupSize);
    } catch (e) {
      console.error('couldn\'t calculate max group size - returing 3 (?)', e);
      _maxGroupSize = 3;
    }
    return _maxGroupSize;
  }
}

export default GalleryLayout;



// WEBPACK FOOTER //
// ./components/gallery/galleryLayout.js